import SellerInfo from '../../../../components/seller-info-label/seller-info.desktop';
import sellerExperiment from './seller-experiment';

const configuredSellerInfo = sellerExperiment(SellerInfo);
export default configuredSellerInfo;
